import type { Recommendation } from '../../types/analysis.types';

export const vibeMapperRecommendations: Recommendation[] = [
  {
    id: 'rec1',
    title: 'Implement SAST tools',
    description:
      'Add static application security testing to detect vulnerabilities in source code before deployment. SonarQube or Semgrep integrates with GitLab CI.',
    priority: 'High',
    category: 'Security',
    estimatedTime: '1-2 weeks',
    impact:
      'Catches SQL injection, XSS, insecure configurations, and other code-level vulnerabilities before they reach production.',
    steps: [
      'Evaluate SAST tools (SonarQube Community, Semgrep, GitLab SAST)',
      'Add SAST stage to .gitlab-ci.yml',
      'Configure rules for TypeScript and Python codebases',
      'Set quality gate to block MRs with critical findings',
      'Triage and resolve initial findings',
    ],
  },
  {
    id: 'rec2',
    title: 'Enable secret detection tools',
    description:
      'Prevent accidental credential leaks by scanning commits for secrets. Gitleaks is lightweight and integrates with pre-commit hooks and CI.',
    priority: 'High',
    category: 'Security',
    estimatedTime: '2-3 days',
    impact:
      'Prevents hardcoded API keys, database passwords, and tokens from entering the repository. Reduces breach risk.',
    steps: [
      'Install Gitleaks and add pre-commit hook',
      'Add Gitleaks scan stage to GitLab CI pipeline',
      'Run baseline scan on existing repository history',
      'Configure allowlist for known false positives',
      'Document secret handling guidelines for contributors',
    ],
  },
  {
    id: 'rec3',
    title: 'Adopt dependency automation',
    description:
      'Configure Renovate or Dependabot to automatically create merge requests for outdated dependencies. Currently 65% of dependencies are outdated.',
    priority: 'Medium',
    category: 'Build',
    estimatedTime: '3-5 days',
    impact:
      'Reduces dependency drift, patches known vulnerabilities faster, and reduces manual update burden.',
    steps: [
      'Choose tool (Renovate recommended for GitLab support)',
      'Create renovate.json with automerge rules for patch updates',
      'Configure grouping for related packages (e.g., @types/*)',
      'Set schedule for weekly minor/major update MRs',
      'Add CI validation for dependency update MRs',
    ],
  },
];
